<template>
  <div class="page-shell page-shell--organization">
    <section class="page-shell__content">
      <div class="page-shell__grid organization_main">
        <div
          class="page-shell__panel organization_tree"
          v-loading="orgLoading"
          v-permit="'Enterprise.Organization.List'"
        >
          <div class="page-shell__panel-header organization_tree__header">
            <div>
              <div class="page-shell__panel-title">组织架构</div>
              <div class="page-shell__panel-subtitle">
                选择机构后，在右侧查看成员并继续管理员工账户。
              </div>
            </div>
          </div>
          <div class="organization_tree__body">
            <el-tree
              ref="organizationTree"
              :data="treeData"
              :expand-on-click-node="false"
              node-key="orgID"
              default-expand-all
              highlight-current
              @node-click="changeDepClick"
            >
              <flexbox slot-scope="{ node, data }" class="node-data">
                <img
                  v-if="node.expanded"
                  class="node-img"
                  src="@/assets/images/fold.png"
                  @click="handleExpand('close', node, data)"
                />
                <img
                  v-if="!node.expanded"
                  class="node-img"
                  src="@/assets/images/unfold.png"
                  @click="handleExpand('open', node, data)"
                />
                <div class="node-label">{{ node.data.name }}</div>
                <div class="node_operate">
                  <el-dropdown trigger="click" @command="roleHandleClick">
                    <span class="el-dropdown-link">
                      <i
                        class="el-icon-arrow-down el-icon--right"
                        @click="roleDropdownClick(data)"
                      ></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        v-permit="'Enterprise.Organization.Create'"
                        command="add"
                        >添加下级机构</el-dropdown-item
                      >
                      <el-dropdown-item
                        v-permit="'Enterprise.Organization.Update'"
                        v-if="data.parentID"
                        command="modify"
                        >修改</el-dropdown-item
                      >
                      <el-dropdown-item
                        v-permit="'Enterprise.Organization.Delete'"
                        v-if="data.parentID"
                        command="delete"
                        >删除</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </flexbox>
            </el-tree>
          </div>
        </div>
        <div
          class="page-shell__panel organization_table"
          v-permit="'Enterprise.Organization.User.List'"
        >
          <div class="page-shell__panel-header organization_table__header">
            <div>
              <div class="page-shell__panel-title">{{ currentOrgName }}</div>
              <div class="page-shell__panel-subtitle">
                当前机构成员列表，支持搜索、新增、编辑、删除和密码维护。
              </div>
            </div>
          </div>
          <public-table
            v-loading="userLoading"
            :column="fieldList"
            :tableData="tableData"
            :PageInfo="listQuery"
            :enableSearch="true"
            :searchItems="searchItems"
            :onAdd="() => addNewUser()"
            addPerm="Enterprise.Organization.User.Create"
            @handlePaginationChange="handleCurrentChange"
          >
            <template v-slot:operate="{ row }">
              <el-button
                size="mini"
                v-permit="'Enterprise.Organization.User.Update'"
                type="text"
                @click="handleEdit(row)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                v-permit="'Enterprise.Organization.UserChangePassword'"
                type="text"
                @click="handleEditPwd(row)"
                >修改密码
              </el-button>
              <el-button
                size="mini"
                v-permit="'Enterprise.Organization.User.Delete'"
                type="text"
                @click="handleDelete(row)"
                >删除</el-button
              >
            </template>
          </public-table>
        </div>
      </div>
      <!-- 组织结构添加修改 -->
      <el-dialog
        class="customDialogForm"
      :visible.sync="orgCreateDialog"
      :title="orgDialogTit"
      :close-on-click-modal="false"
      width="30%"
      >
        <el-form
          :model="editOrg"
          :rules="orgRules"
          ref="orgform"
          label-width="80px"
        >
          <div class="nav-dialog-div" v-if="editOrg.parentID">
            <el-form-item label="上级组织" prop="parentID">
              <el-select v-model="editOrg.parentID" style="width: 100%">
                <el-option
                  v-for="(item, key) in orgAllList"
                  :key="key"
                  :label="item"
                  :value="key"
                />
              </el-select>
            </el-form-item>
          </div>
          <div class="nav-dialog-div">
            <el-form-item prop="name" label="名称">
              <el-input v-model="editOrg.name" placeholder="请输入内容" />
            </el-form-item>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="orgCreateDialog = false">取 消</el-button>
          <el-button type="primary" @click="orgDialogOk">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 新建和编辑 -->
      <el-dialog
        class="customDialogForm"
      :title="userdialogTitle"
      :visible.sync="userCreateDialog"
      :close-on-click-modal="false"
      :popper-append-to-body="false"
      :append-to-body="true"
      width="800px"
      >
        <el-form
          ref="dialogRef"
          :inline="true"
          :model="userFormData"
          :rules="dialogRules"
          class="new-dialog-form"
          label-width="80px"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item v-if="isAddNewUser" label="用户名" prop="username">
                <el-input
                  class="w255"
                  v-model.trim="userFormData.username"
                  placeholder="请输入用户名"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="姓名" prop="realName">
                <el-input
                  class="w255"
                  v-model.trim="userFormData.realName"
                  placeholder="请输入姓名"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="组织机构" prop="orgID">
                <el-select
                  v-model="userFormData.orgID"
                  placeholder="请选择"
                  style="width: 180px"
                >
                  <el-option
                    v-for="(item, key) in orgAllList"
                    :key="key"
                    :label="item"
                    :value="key"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机号码" prop="phone">
                <el-input
                  class="w255"
                  v-model="userFormData.phone"
                  placeholder="请输入手机号码"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item v-if="isAddNewUser" label="密码" prop="password">
                <el-input
                  class="w255"
                  type="password"
                  v-model="userFormData.password"
                  placeholder="请输入密码"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item v-if="isAddNewUser" label="邮箱" prop="email">
                <el-input
                  class="w255"
                  v-model="userFormData.email"
                  placeholder="请输入邮箱地址"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="userCreateDialog = false">取 消</el-button>
          <el-button type="primary" @click="userDialogSubmit">保 存</el-button>
        </span>
      </el-dialog>
      <!-- 修改密码 -->
      <el-dialog
        class="customDialogForm"
      :visible.sync="resetPasswordVisible"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      title="修改密码"
      width="30%"
      >
        <div class="el-password">
          <el-form :model="passForm" :rules="passRules" ref="passform">
            <el-form-item prop="newPassword" label="新密码">
              <el-input v-model="passForm.newPassword" type="password" />
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="resetPasswordVisible = false">取 消</el-button>
          <el-button type="primary" @click="passSubmit">确 定</el-button>
        </span>
      </el-dialog>
    </section>
  </div>
</template>
<script>
import {
  addOrgApi,
  addUserApi,
  deleteOrgApi,
  deleteUserApi,
  getAllUserListApi,
  getOrgStructureApi,
  modifyOrgApi,
  modifyUsersApi,
  modifyUserPwdApi
} from '@/api/enterpriseManage';
import { errorHandle } from '@/utils/error';
export default {
  data() {
    return {
      orgLoading: true,
      userLoading: true,
      userInfo: {},
      treeData: [],
      formInline: {},
      tableData: [],
      currentPage: 1,
      pageSizes: [15, 30, 45, 60],
      pageSize: 15,
      total: 0,
      fieldList: [
        { prop: 'realName', label: '姓名', width: '150px' },
        { prop: 'username', label: '用户名', width: '150px' },
        { prop: 'phone', label: '手机号码', width: '120px' },
        { prop: 'email', label: '邮箱', width: '150px' },
        { prop: 'orgName', label: '组织机构' },
        {
          prop: 'operate',
          label: '操作',
          scopeStatus: true
        }
      ],
      listQuery: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      selectionList: [], // 批量勾选数据
      statusOptions: [
        { value: '0', label: '禁用' },
        { value: '1', label: '激活' },
        { value: '2', label: '未激活' }
      ],
      // 组织机构
      rootOrgId: '',
      curOrgData: {},
      orgCreateDialog: false,
      orgDialogTit: '新增组织',
      orgSelect: '',
      orgAllList: [],
      orgTitle: '',
      editOrg: {
        eid: '',
        parentID: '',
        name: ''
      },
      isAddNewData: false,
      curTreeSelectedOrgId: '',
      // 用户
      userdialogTitle: '创建用户',
      userCreateDialog: false,
      userFormData: {},
      passRules: {
        newPassword: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          { min: 6, message: '最小6个字符', trigger: 'blur' },
          { max: 255, message: '最大255个字符', trigger: 'blur' }
        ]
      },
      orgRules: {
        name: [
          { required: true, message: '组织名称不能为空', trigger: 'blur' },
          { min: 2, message: '最小2个字符', trigger: 'blur' },
          { max: 255, message: '最大255个字符', trigger: 'blur' }
        ],
        orgSelect: []
      },
      dialogRules: {
        username: [
          { required: true, message: '用户名不能为空', trigger: 'blur' },
          { max: 255, message: '最大255个字符', trigger: 'blur' }
        ],
        realName: [
          { required: true, message: '姓名不能为空', trigger: 'blur' },
          { max: 255, message: '最大255个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          { min: 6, message: '长度至少为6个字符', trigger: 'blur' },
          { max: 30, message: '最大30个字符', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '手机号码不能为空', trigger: 'blur' },
          {
            pattern: /^1\d{10}$/,
            message: '目前只支持中国大陆的手机号码',
            trigger: 'blur'
          }
        ],
        email: [
          { required: true, message: '邮箱不能为空', trigger: 'blur' },
          {
            pattern:
              /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,
            message: '请输入正确的邮箱格式',
            trigger: 'blur'
          }
        ],
        orgID: [
          { required: true, message: '组织机构不能为空', trigger: 'change' }
        ]
      },
      isAddNewUser: false,
      // 修改密码
      resetPasswordVisible: false,
      passForm: {},
      searchItems: [
        {
          label: '员工名称',
          span: 12,
          name: 'name',
          value: '',
          type: 'input'
        }
      ],
      curHandleRole: null
    };
  },
  computed: {
    currentOrgName() {
      const currentID = this.curTreeSelectedOrgId || this.rootOrgId;
      return this.orgAllList[currentID] || '成员列表';
    }
  },
  created() {
    this.userInfo = this.$store.getters.userInfo;
    if (this.userInfo.eid) {
      this.initData();
    } else {
      setTimeout(() => {
        this.userInfo = this.$store.getters.userInfo;
        this.initData();
      }, 1200);
    }
  },
  methods: {
    // 角色操作点击
    roleHandleClick(cmd) {
      const data = this.curHandleRole;
      if (cmd === 'add') {
        this.orgAppend(data);
      } else if (cmd === 'modify') {
        this.orgEdit(data);
      } else {
        this.orgRemove(data);
      }
    },
    // 角色操作
    roleDropdownClick(role) {
      this.curHandleRole = role;
    },
    initData() {
      this.getOrgData();
    },
    // 展开闭合操作
    handleExpand(type, node, data) {
      if (type == 'close') {
        if (data.children) node.expanded = false;
      } else if (type == 'open') {
        node.expanded = true;
      }
    },
    // 新增组织
    orgAppend(data) {
      this.orgCreateDialog = true;
      this.orgDialogTit = '新增组织';
      this.isAddNewData = true;
      this.editOrg = {
        parentID: data.orgID,
        name: ''
      };
    },
    orgEdit(data) {
      this.curOrgData = data;
      this.orgCreateDialog = true;
      this.orgDialogTit = '修改组织';
      this.isAddNewData = false;
      this.editOrg = {
        parentID: data.parentID,
        name: data.name
      };
    },
    orgRemove(data) {
      this.$confirm('确认要删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteOrgApi({
            eid: this.userInfo.eid,
            orgID: data.orgID
          })
            .then((res) => {
              this.getOrgData();
              this.$message.success('删除成功');
            })
            .catch((err) => {
              errorHandle(err);
            });
        })
        .catch(() => {});
    },
    // 组织选中
    changeDepClick(data) {
      if (this.curTreeSelectedOrgId === data.orgID) {
        return null;
      }
      this.getAlluser(data.orgID);
      this.curTreeSelectedOrgId = data.orgID;
    },
    // 第一列点击事件
    rowClick(row, column, event) {
      this.dialogData = row;
      if (column.property == 'realname') {
        this.employeeDetailDialog = true;
      }
    },
    // 勾选
    handleSelectionChange(val) {
      this.selectionList = val; // 勾选的行
    },
    // 获取状态颜色
    getStatusColor(status) {
      if (status == 0) {
        return '#FF6767';
      } else if (status == 1) {
        return '#46CDCF';
      } else if (status == 2) {
        return '#CCCCCC';
      }
    },
    // 更改当前页数
    handleCurrentChange(data) {
      this.listQuery.page = 1;
      data = data || {};
      this.listQuery = { ...this.listQuery, ...data };
      this.getAlluser(this.curTreeSelectedOrgId);
    },
    // 获取组织数据
    getOrgData() {
      this.orgLoading = true;
      getOrgStructureApi({
        eid: this.userInfo.eid
      })
        .then((res) => {
          this.rootOrgId = res.orgID;
          this.getAlluser();
          if (res) this.treeData = [res];
          const list = {};
          this.treeData.forEach((item) => {
            // list.push({orgID: item.orgID, name: item.name});
            list[item.orgID] = item.name;
            if (item.children) this.getChildrenOrg(list, item.children);
          });
          this.orgAllList = list;
          this.orgLoading = false;
        })
        .catch((err) => {
          errorHandle(err);
          this.orgLoading = false;
        });
    },
    getChildrenOrg(list, data) {
      data.forEach((item) => {
        // list.push({orgID: item.orgID, name: item.name});
        list[item.orgID] = item.name;
        if (item.children) this.getChildrenOrg(list, item.children);
      });
    },
    // 保存组织数据
    orgDialogOk() {
      this.$refs.orgform.validate((valid) => {
        if (valid) {
          if (this.isAddNewData) {
            addOrgApi({
              eid: this.userInfo.eid,
              parentID: this.editOrg.parentID,
              name: this.editOrg.name
            })
              .then((res) => {
                this.orgCreateDialog = false;
                this.getOrgData();
                this.$message.success('操作成功');
              })
              .catch((err) => {
                errorHandle(err);
              });
          } else {
            modifyOrgApi({
              eid: this.userInfo.eid,
              parentID: this.editOrg.parentID,
              name: this.editOrg.name,
              orgID: this.curOrgData.orgID
            })
              .then((res) => {
                this.orgCreateDialog = false;
                this.getOrgData();
                this.$message.success('操作成功');
              })
              .catch((err) => {
                errorHandle(err);
              });
          }
        }
      });
    },
    // 组织用户列表
    getAlluser(id) {
      this.userLoading = true;
      let params = {
        eid: this.userInfo.eid,
        orgID: id || this.rootOrgId
      };
      params = { ...params, ...this.listQuery };
      getAllUserListApi(params)
        .then((res) => {
          if (res) {
            res.data &&
              res.data.forEach((item) => {
                item.orgName = this.orgAllList[item.orgID];
              });
            this.tableData = res.users;
            this.listQuery.total = res.total;
            this.userLoading = false;
          }
        })
        .catch((err) => {
          errorHandle(err);
          this.userLoading = false;
        });
    },
    // 新增用户
    addNewUser() {
      this.isAddNewUser = true;
      this.userdialogTitle = '添加员工';
      this.userCreateDialog = true;
      this.userFormData = {};
      this.$nextTick(() => {
        this.$refs.dialogRef.clearValidate();
      });
    },
    // 保存用户数据
    userDialogSubmit() {
      this.$refs.dialogRef.validate((valid) => {
        if (valid) {
          if (this.isAddNewUser) {
            this.userFormData.eid = this.userInfo.eid;
            addUserApi(this.userFormData)
              .then((res) => {
                this.userCreateDialog = false;
                this.$message.success('操作成功');
                this.getAlluser();
              })
              .catch((re) => {
                errorHandle(re);
              });
          } else {
            modifyUsersApi(this.userFormData)
              .then((res) => {
                this.userCreateDialog = false;
                this.$message.success('操作成功');
                this.getAlluser();
              })
              .catch((err) => {
                errorHandle(err);
              });
          }
        }
      });
    },
    // 编辑
    handleEdit(row) {
      this.userCreateDialog = true;
      this.isAddNewUser = false;
      this.userdialogTitle = '修改员工信息';
      this.userFormData = JSON.parse(JSON.stringify(row));
      this.$nextTick(() => {
        this.$refs.dialogRef.clearValidate();
      });
    },
    // 删除
    handleDelete(row) {
      this.$confirm('确认要删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteUserApi({
            eid: row.eid,
            userID: row.userID
          })
            .then((res) => {
              this.getAlluser();
              this.$message.success('删除成功');
            })
            .catch((err) => {
              errorHandle(err);
            });
        })
        .catch(() => {});
    },
    // 修改密码
    handleEditPwd(row) {
      this.resetPasswordVisible = true;
      this.curUserData = row;
    },
    passSubmit() {
      this.$refs.passform.validate((valid) => {
        if (valid) {
          modifyUserPwdApi({
            eid: this.curUserData.eid,
            userID: this.curUserData.userID,
            newPassword: this.passForm.newPassword
          })
            .then((res) => {
              this.resetPasswordVisible = false;
              this.$message.success('操作成功');
            })
            .catch((re) => {
              errorHandle(re);
            });
        }
      });
    },
    // 搜索员工
    searchUser() {
      this.getAlluser(this.curTreeSelectedOrgId);
    }
  }
};
</script>
<style scoped lang="scss">
@import 'src/styles/page-shell.scss';

.w255 {
  width: 255px;
}

.organization_main {
  grid-template-columns: 280px minmax(0, 1fr);
}

.organization_tree {
  padding: 20px 18px 18px;
  overflow: hidden;
}

.organization_table {
  padding: 20px;
}

.organization_tree__body {
  min-height: 520px;
  padding-top: 6px;
  overflow-x: auto;
}

::v-deep .organization_tree .el-tree .el-tree-node__content {
  height: 42px;
  margin-bottom: 4px;
  border-radius: 12px;
  transition: background-color 0.2s ease;
}

::v-deep .organization_tree .el-tree .el-tree-node__expand-icon {
  display: none;
}

::v-deep .organization_tree .el-tree {
  background: transparent;
}

::v-deep .organization_tree .el-tree .el-tree-node__content .node-data .node-img {
  width: 15px;
  height: 15px;
  display: block;
  margin: 0 8px;
}

.organization_tree .node-data {
  gap: 6px;
}

.organization_tree .node_operate {
  padding-left: 5px;
  display: none;
}

::v-deep .organization_tree .el-tree-node__content:hover {
  background: rgba(240, 246, 251, 0.96);
}

::v-deep .organization_tree .el-tree-node__content:hover .node_operate {
  display: flex;
  align-items: center;
}

::v-deep .organization_tree
  .el-tree
  .el-tree-node.is-current
  > .el-tree-node__content {
  background: rgba(220, 234, 246, 0.9);
}

::v-deep .organization_tree
  .el-tree
  .el-tree-node.is-current
  > .el-tree-node__content
  .node_operate {
  display: flex;
  align-items: center;
}

::v-deep .organization_tree .el-button + .el-button {
  margin-left: 5px;
}

::v-deep .organization_tree .el-dropdown-link {
  display: inline-flex;
  align-items: center;
  color: #7b90a6;
}

.org_name_input {
  width: 240px;
}
.org_form_wrap {
  position: relative;
}
.org_add_btn {
  position: absolute;
  right: 20px;
  top: 0;
}

.status-des {
  font-size: 12px;
  color: #777777;
  margin: 0 5px;
}
.status-des .status-des-item {
  margin: 8px;
  display: inline-block;
}
.status-des .status-des-item di {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 3px;
  margin-right: 5px;
}
.status-des .status-des-item div {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 3px;
  margin-right: 5px;
}
/* 表格 */
::v-deep .organization_table .common-table {
  padding: 0;
}

::v-deep .organization_table .common-table__toolbar {
  padding-bottom: 18px;
}

::v-deep .organization_table .el-table thead th {
  background-color: #f2f2f2;
  font-weight: 400;
  font-size: 13px;
}

::v-deep .organization_table .table-head-name {
  color: #909399;
  font-size: 13px;
  line-height: 23px;
  padding: 0;
}

::v-deep .organization_table .el-table thead .cell {
  height: 23px;
}

::v-deep .organization_table .el-table tbody tr td {
  font-size: 13px;
}
/* 新建和编辑 */
.new-dialog-title {
  padding-left: 10px;
  margin-bottom: 3px;
  border-left: 2px solid #46cdcf;
}
.node-label {
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (max-width: 1080px) {
  .organization_main {
    grid-template-columns: 1fr;
  }

  .organization_tree,
  .organization_table {
    padding-left: 16px;
    padding-right: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/information/organization/index.vue